import { ImageSliderAnalyticsEvent } from '@liveauctioneers/hammer-ui-core/imageSlider';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

import { TrackingEvents, TrackingPayload } from '../core.types';

type TrackItemImageGalleryInteractionPayload = ImageSliderAnalyticsEvent & TrackingPayload;

const trackItemImageGalleryInteractionAnalytics = (payload: TrackItemImageGalleryInteractionPayload) => {
    track(TrackingEvents.Item.ItemImageGalleryInteractionClicked, payload);
};

export const useTrackItemImageGalleryInteractionAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ imagePosition, interactionType, totalImages }: ImageSliderAnalyticsEvent) => {
            return trackItemImageGalleryInteractionAnalytics({
                imagePosition,
                interactionType,
                pageName: getAmplitudePageNameFromPath(pathname),
                totalImages,
                url,
            });
        },
        [pathname, url]
    );
};
